<template>
	<v-row no-gutters>
		<v-autocomplete
			solo
			v-model="product"
			:items="productOptions"
			:loading="loadingProducts"
			:search-input.sync="search"
			hide-selected
			hide-details
			item-text="name"
			item-value="id"
			:placeholder="$gettext('Search...')"
			clearable
			return-object
			outlined
			no-filter
			:no-data-text="$gettext('No results found')"
			@input="addProduct"
			prepend-inner-icon="search"
		>
			<template slot="item" slot-scope="{ parent, item }">
				<v-col cols="12" md="12" class="pa-0">
					<div v-if="substance" @click.capture="clickProduct($event, item)">
						<SubstanceItem :product="item" type="supplement" />
					</div>
					<v-list-item v-else :key="item.id" style @click.capture="clickProduct($event, item)">
						<v-list-item-icon class="mr-3">
							<v-icon v-if="type === 'supplement'" color="primary">mdi-pill</v-icon>
							<v-icon v-else color="primary">$vuetify.icons.tcmIcon</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="mb-2">
								<template v-if="type === 'supplement'">
									<strong v-if="item.product.id == -1">{{item.product.name}}</strong>
									<template v-else>
										<strong>{{item.product.name}}</strong>
										<template v-if="!item.product.complex_product && item.product.unit">
											<strong> ({{item.product.units_box}} {{item.product.unit.code}})</strong>
										</template>
									</template>
								</template>
								<template v-if="type === 'formula'">
									<strong>{{item.product.name}}</strong>
								</template>
							</v-list-item-title>
							<v-list-item-subtitle>
								<v-row no-gutters align="center">
									<template v-if="item.product.external_entity">
										<v-icon class="mr-1" small color="primary">mdi-store</v-icon>
										<span class="mr-2">{{item.product.external_entity.name}}</span>
									</template>
									<template v-if="item.product.classic">
										<v-icon class="mr-1" small color="primary">mdi-spa</v-icon>
										<span class="mr-2" v-translate>Classic</span>
									</template>
									<template v-if="item.product.classic || item.product.customizable">
										<v-icon class="mr-1" small color="primary">mdi-file-document-edit-outline</v-icon>
										<span v-if="item.product.classic_custom || item.product.lab_custom" v-translate>Customized</span>
										<span v-else v-translate>Customizable</span>
									</template>
									<v-spacer></v-spacer>
									<template v-if="item.product.storage">
										<v-icon class="mr-1" small color="primary">mdi-bottle-tonic-plus</v-icon>
										<span class="mr-2">{{item.product.storage.name}}</span>
									</template>
									<template v-if="item.product.presentation">
										<v-icon class="mr-1" small color="primary">mdi-water</v-icon>
										<span>{{item.product.presentation.name}}</span>
									</template>
								</v-row>
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-col>
			</template>
		</v-autocomplete>
		<FilterProviders v-if="providersFilter" />
		<v-dialog v-model="classicFormulaSubstancesDialog" max-width="40%" scrollable>
			<v-card key="choose-formula" v-if="chooseFormulaStep">
				<v-card-title class="title primary--text mb-2 secondary" v-translate>Choose Provider</v-card-title>
				<v-card-text>
					<v-list rounded>
						<v-list-item-group
							v-model="selectedFormula"
						>
							<template v-for="(formula, i) in customizableFormulas">
								<v-divider
									v-if="false"
									:key="`divider-${i}`"
								></v-divider>

								<div :key="`no-provider-${i}`" v-if="i == 0">
									<span class="text-body-1 primary--text" v-translate>No Provider</span>
									<v-divider class="my-2"></v-divider>
								</div>

								<v-list-item
									:key="formula.id"
									:value="formula"
									active-class="primary--text"
								>
									<template v-slot:default="{ active }">
										<v-list-item-icon class="mr-3">
											<v-icon color="primary">$vuetify.icons.tcmIcon</v-icon>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title>
												<strong>{{formula.name}}</strong>
											</v-list-item-title>
											<v-list-item-subtitle class="mt-2">
												<template v-if="formula.external_entity">
													<v-icon class="mr-1" small color="primary">mdi-store</v-icon>
													<span class="mr-2">{{formula.external_entity.name}}</span>
												</template>
												<template v-else>
													<v-icon class="mr-1" small color="primary">mdi-spa</v-icon>
													<span class="mr-2" v-translate>Classic</span>
												</template>
												<template v-if="formula.classic || formula.customizable || formula.classic_custom || formula.lab_custom">
													<v-icon class="mr-1" small color="primary">mdi-file-document-edit-outline</v-icon>
													<span v-if="formula.classic_custom || formula.lab_custom" v-translate>Customized</span>
													<span v-else v-translate>Customizable</span>
												</template>
											</v-list-item-subtitle>
										</v-list-item-content>

										<v-list-item-action>
											<v-checkbox
												:input-value="active"
												color="primary"
											></v-checkbox>
										</v-list-item-action>
									</template>
								</v-list-item>

								<div :key="`provider-${i}`" v-if="i == 0">
									<span class="text-body-1 primary--text" v-translate>Providers</span>
									<v-divider class="my-2"></v-divider>
								</div>

								<p :key="`no-list-provider${i}`" v-if="customizableFormulas.length == 1" class="grey--text my-3" v-translate>No provider formulas.</p>
							</template>
						</v-list-item-group>
					</v-list>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text :disabled="!selectedFormula" @click="chooseFormula">
						<translate>Choose</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
			<v-card key="substances" v-else-if="formulaSubstancesStep">
				<v-card-title class="title primary--text mb-2 secondary" v-translate>Substance Quantities (g)</v-card-title>
				<v-card-text>
					<v-row no-gutters>
						<v-btn
							class="mx-2"
							dark
							x-small
							fab
							color="primary"
							@click="formulaSubstancesStep = false; chooseFormulaStep = true"
						>
							<v-icon>mdi-arrow-left</v-icon>
						</v-btn>
					</v-row>
					<v-form ref="substancesForm" v-model="substancesFormValid">
						<v-row no-gutters class="mt-3">
							<v-col v-for="ing in classicFormulaSubstances" cols="12" sm="6" :key="ing.id">
								<v-text-field
									:rules="substanceQuantityRules"
									v-model="ing.quantity"
									:label="ing.name"
									class="px-2"
									outlined
									type="number"
								/>
							</v-col>
						</v-row>
						<!-- <v-select
							:rules="substanceQuantityRules"
							:items="presentations"
							item-text="name"
							item-value="id"
							v-model="presentationId"
							:label="$gettext('Presentation')"
							class="px-2"
							outlined
						/> -->
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="addClassicFormula">
						<translate>Add</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="selectedSubstanceQuantityDialog" max-width="40%" scrollable>
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary" v-translate>Substance Quantity</v-card-title>
				<v-card-text>
					<v-form ref="substanceQuantityForm" v-model="substanceQuantityFormValid">
						<v-row no-gutters class="mt-3">
							<v-col cols="6">
								<v-text-field
									:rules="substanceQuantityRules"
									v-model="selectedSubstance.quantity"
									:label="selectedSubstance.product.name"
									class="px-2"
									outlined
									type="number"
								/>
							</v-col>
							<v-col cols="6">
								<v-select
									v-model="selectedSubstance.unit"
									:items="availableUnits"
									:label="$gettext('Unit')"
									item-text="name"
									item-value="code"
									outlined
									:rules="substanceQuantityRules"
									class="px-2"
								></v-select>
							</v-col>
						</v-row>
						<v-row no-gutters v-if="!selectedSubstance.product.complex_substance">
							<v-col cols="6">
								<v-select
									v-model="selectedSubstance.processing"
									:items="availableProcessing"
									:label="$gettext('Processing')"
									class="px-2"
									item-text="name"
									item-value="id"
									outlined
									return-object
								></v-select>
							</v-col>
							<v-col cols="6">
								<v-text-field
									v-model="selectedSubstance.info"
									:label="$gettext('Info')"
									class="px-2"
									outlined
								/>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="addSubstance">
						<translate>Add</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import axios from "axios";
import SubstanceItem from "@/components/products/SubstanceItem.vue";
import FilterProviders from '@/components/products/FilterProviders.vue';

export default {
	name: "SearchProducts",
	props: ["type", "substance", "method", "availableProcessing", "context", "providersFilter"],
	components: {
		SubstanceItem,
		FilterProviders
	},
	data: () => ({
		product: null,
		productOptions: [],
		search: null,
		loadingProducts: false,
		classicFormulaSubstancesDialog: false,
		classicFormulaSubstances: [],
		presentationId: null,
		substancesFormValid: false,
		classicFormulaId: null,
		selectedSubstance: {
			product: {substance_type: {code: null}},
			quantity: "",
			unit: "g",
			processing: null,
			info: null
		},
		selectedSubstanceQuantityDialog: false,
		substanceQuantityFormValid: false,
		availableUnits: [
			{ name: "ug", code: "ug" },
			{ name: "mg", code: "mg" },
			{ name: "g", code: "g" }
		],
		presentations: [],
		customizableFormulas: [],
		selectedFormula: null,
		chooseFormulaStep: true,
		formulaSubstancesStep: false
	}),
	methods: {
		isInt(n) {
			return Number(n) === n && n % 1 === 0;
		},
		isFloat(n) {
			return Number(n) === n && n % 1 !== 0;
		},
		clickProduct(event, product) {
			if (this.method == "get") {
				event.stopPropagation();
				event.preventDefault();
				this.productOptions = [];
				this.search = null;
				this.$emit("click", product.product.id);
			}
			if (this.substance && this.method != "get") {
				console.log("ADD PRODUCT");
				event.stopPropagation();
				event.preventDefault();
				this.selectedSubstance = product;
				this.selectedSubstance.quantity = "";
				this.selectedSubstance.unit = "";
				this.selectedSubstanceQuantityDialog = true;
			}
			if (this.type === "formula" && (product.product.classic || product.product.customizable) && this.method != "get") {
				console.log("CLASSIC FORMULA");
				event.stopPropagation();
				event.preventDefault();
				this.classicFormulaId = product.product.id;
				this.classicFormulaSubstances = product.product.ingredients;
				this.classicFormulaSubstancesDialog = true;
				this.selectedFormula = product.product;
				this.getCustomizableFormulas(product.product);
			}
		},
		chooseFormula() {
			this.classicFormulaId = this.selectedFormula.id;
			this.classicFormulaSubstances = this.selectedFormula.ingredients;
			this.chooseFormulaStep = false;
			this.formulaSubstancesStep = true;
		},
		addProduct() {
			if (this.product) {
				console.log(this.product);
				const productId = this.product.product.id;
				if (productId == -1) this.$emit("new-product", this.search);
				else this.$emit("add-product", productId);
				this.product = null;
				this.search = null;
				this.productOptions = [];
			}
		},
		addClassicFormula() {
			if (this.validateSubstancesQuantity()) {
				this.$emit(
					"add-product",
					this.classicFormulaId,
					this.classicFormulaSubstances,
					this.presentationId
				);
				this.classicFormulaSubstancesDialog = false;
				this.product = null;
				this.search = null;
				this.productOptions = [];
			}
		},
		addSubstance() {
			if (this.validateSubstanceQuantity()) {
				console.log("valid");
				this.$emit("add-product", this.selectedSubstance);
				this.selectedSubstanceQuantityDialog = false;
			}
		},
		validateSubstancesQuantity() {
			return this.$refs.substancesForm.validate();
		},
		validateSubstanceQuantity() {
			return this.$refs.substanceQuantityForm.validate();
		},
		makeRequest() {
			clearTimeout(this._timerId);
			this.loadingProducts = true;
			if (this.search != null) {
				this._timerId = setTimeout(() => {
					console.log("API CALL");
					var link = this.type == "supplement" ? "/products/list" : "/mtc/formulas";
					var type = this.substance ? "substance" : "compost";
					var appointmentId = this.context != "new-product" ? this.$route.params.aid : "";
					axios
						.get(link, {
							params: {
								context: this.context,
								keyword: this.search.toLowerCase(),
								"search-filter": "all",
								"search-type": "product-name",
								type: type,
								appointment: appointmentId
							}
						})
						.then(response => {
							if (response.data.length == 0 && this.context === "appointment") {
								this.productOptions = [{ product: {id: -1, name: this.search + " (" + this.$gettext("Create New Product") + ")"}}];
							} else {
								this.productOptions = response.data;
							}
							console.log(response.data);
						})
						.catch(error => console.log(error));
					this.loadingProducts = false;
				}, 300);
			}
		},
		getCustomizableFormulas(formula) {
			axios
				.get(`/mtc/formulas/${formula.id}/customizable`)
				.then(response => {
					console.log(response.data);
					this.customizableFormulas = response.data;
					this.customizableFormulas.unshift(formula);
				})
				.catch(error => console.log(error));
		}
		// getPresentations() {
		// 	axios
		// 		.get("/product-presentations")
		// 		.then(response => {
		// 			console.log(response.data);
		// 			this.presentations = response.data;
		// 		})
		// 		.catch(error => console.log(error));
		// }
	},
	computed: {
		substanceQuantityRules() {
			return [v => !!v || this.$gettext("Required")];
		}
	},
	watch: {
		search(value) {
			console.log(value);
			if (!value) {
				return;
			}
			this.makeRequest();
		},
		// classicFormulaSubstancesDialog(value) {
		// 	if(value && this.presentations.length == 0) {
		// 		this.getPresentations();
		// 	}
		// }
	}
};
</script>